import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_api_connections_configuration_card = _resolveComponent("api-connections-configuration-card")!
  const _component_new_api_connections_configuration_modal = _resolveComponent("new-api-connections-configuration-modal")!
  const _component_base_confirmation_modal = _resolveComponent("base-confirmation-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "d-flex" }, {
      default: _withCtx(() => [
        ($setup.showNewConfigurationButton)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "ml-auto",
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showNewConfigurationModal = true))
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('new')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localConfigurations, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_row, {
        key: index,
        class: "d-block mt-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_api_connections_configuration_card, {
            configuration: item,
            "configuration-history": $setup.apiConnectionConfigurationHistory,
            onUpdate: (payload) => $setup.handleConfigurationUpdate(index, payload),
            onDelete: ($event: any) => ($setup.handleConfigurationDelete(index)),
            onSave: ($event: any) => ($setup.handleConfigurationSave(index)),
            onFetchHistory: ($event: any) => ($setup.fetchApiConnectionConfigurationHistory(item.apiName!))
          }, null, 8, ["configuration", "configuration-history", "onUpdate", "onDelete", "onSave", "onFetchHistory"])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_new_api_connections_configuration_modal, {
      "model-value": $setup.showNewConfigurationModal,
      "existing-api-names-values": $setup.remainingApiNames,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showNewConfigurationModal = false)),
      onConfirm: $setup.handleConfigurationCreate
    }, null, 8, ["model-value", "existing-api-names-values", "onConfirm"]),
    _createVNode(_component_base_confirmation_modal, {
      modelValue: $setup.showDeleteConfigurationModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showDeleteConfigurationModal) = $event)),
      "feedback-text": _ctx.$t('configurationDeleted'),
      onConfirm: $setup.deleteConfiguration,
      onClose: _cache[3] || (_cache[3] = ($event: any) => {
      {
        $setup.apiNameToBeDeleted = null;
        $setup.showDeleteConfigurationModal = false;
      }
    })
    }, {
      content: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('confirmDeleteConfiguration')), 1),
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('confirmDeleteConfigurationNote')), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "feedback-text", "onConfirm"])
  ], 64))
}